export type EosTodoStatus = 'open' | 'done' | 'cancelled';
export type EosTodoPriority = 'low' | 'medium' | 'high';

export const EOS_TODO_STATUSES: EosTodoStatus[] = ['open', 'done', 'cancelled'];
export const EOS_TODO_PRIORITIES: EosTodoPriority[] = ['low', 'medium', 'high'];

export const EOS_TODO_STATUS_LABELS: Record<EosTodoStatus, string> = {
  open: 'Open',
  done: 'Done',
  cancelled: 'Cancelled',
};

export const EOS_TODO_PRIORITY_LABELS: Record<EosTodoPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

export interface EosTodo {
  id: string;
  title: string;
  description: string | null;
  ownerId: string;
  teamId: string | null;
  createdFromMeetingId: string | null;
  dueDate: string;
  status: EosTodoStatus;
  priority: EosTodoPriority;
  completedAt: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface EosTodoFilters {
  owner_id?: string;
  owner_ids?: string[];
  team_id?: string;
  status?: EosTodoStatus;
  priority?: EosTodoPriority;
  due_before?: string;
  due_after?: string;
  search?: string;
  include_completed?: boolean;
  include_cancelled?: boolean;
  sortKey?: 'due_date' | 'created_at' | 'priority' | 'title' | 'status';
  sortDirection?: 'asc' | 'desc';
  pageNumber?: number;
  pageLength?: number;
}

export interface EosTodoListResponse {
  todos: EosTodo[];
  pageNumber: number;
  pageLength: number;
  total: number;
}

export interface CreateEosTodoInput {
  title: string;
  description?: string;
  owner_id: string;
  team_id?: string;
  created_from_meeting_id?: string;
  due_date?: string;
  priority?: EosTodoPriority;
}

export interface UpdateEosTodoInput {
  title?: string;
  description?: string | null;
  owner_id?: string;
  team_id?: string | null;
  due_date?: string;
  priority?: EosTodoPriority;
}
